var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-nav"},[_c('div',{staticClass:"tab-nav-content"},_vm._l((_vm.navList),function(item,index){return _c('div',{key:item.value,class:{
        'nav-item': true,
        'transtion-hover': true,
        'nav-item-active': _vm.value === item.value
      },on:{"click":function($event){return _vm.handleClick($event, item, index)}}},[_vm._v(_vm._s(item.label))])}),0),_c('div',{staticClass:"tab-line transtion-hover",style:(_vm.lineStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }